export default __webpack_public_path__ + "static/media/BidFarewell.996daca5.svg";